import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { interceptor } from "../utils/interceptor";

export const useGenericMutation = ({
    endpoint,
    method = "post",
    body = {},
    onSuccess,
    onError,
    options = {},
}) => {
    const axiosInstance = interceptor();

    const mutationFn = async (payload = body) => {
        const { data } = await axiosInstance({
            url: endpoint,
            method,
            data: payload,
        });
        return data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
            else console.log(`Mutation to ${endpoint} success:`, data);
        },
        onError: (error) => {
            console.log(error)
            if (onError) {
                onError(error);
                return; // ✅ Prevent React from showing overlay
            }
            const msg = error?.response?.data?.error || error?.data?.error || "Error occurred";
            message.error(msg);
            console.error(`Mutation to ${endpoint} error:`, error);
        },
        ...options,
    });
};
